import { Accordion } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const OverviewAdvanceSettingsWrapper = styled.div`
  ${Accordion.S.AccordionHeader} {
    cursor: pointer;
    display: inline-flex;
    gap: 2px;
    justify-content: flex-start;
  }
`;

export { OverviewAdvanceSettingsWrapper };
